import SpriteSymbol from "../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-status-alert-solid",
  "use": "icon-status-alert-solid-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol viewBox=\"0 0 16 16\" id=\"icon-status-alert-solid\"><circle cx=\"8\" cy=\"8\" r=\"6\" fill=\"#fff\" /><path d=\"M8 15c3.9 0 7-3.1 7-7s-3.1-7-7-7-7 3.1-7 7 3.1 7 7 7M7.3 4h1.5v6H7.3zm0 7h1.5v1.5H7.3z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol